//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  head () {
    return {
      title:
        'Manchester Pest Control | Pest Control FAQs',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: 'Manchester Pest Controls most frequently asked questions relating to residential and commercial pest control and wasp nest treatments in the areas we cover around Manchester, Stockport and Cheshire.'
        },
        {
          hid: 'og:title',
          name: 'og:title',
          content: 'Manchester Pest Control | Pest Control FAQs'
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: 'Manchester Pest Controls most frequently asked questions relating to residential and commercial pest control and wasp nest treatments in the areas we cover around Manchester, Stockport and Cheshire.'
        }
      ]
    }
  }
}
